import styled from 'styled-components'
import { BodySmall } from '../../components/typography/styled'


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 24px 24px 40px;
  .chart-legend-item {
    max-width: 100%;
  }
  .chart-legend-item > span:first-child {
    flex-shrink: 0;
  }
  .chart-legend-item > span:nth-child(2) {
    min-width: 0;
    white-space: normal !important;
    overflow-wrap: anywhere;
  }
  @media (max-width: 640px) {
    padding: 16px 16px 32px;
  }
`
type ErrorProp = {
  isError?:boolean
}
export const ErrorContainer = styled.div<ErrorProp>`
  display: ${({isError}) => isError ? 'flex' : 'none'};
  width: 100%;
  /* height: 30px; */
  background: #FFE6E6;
  border-radius: 4px;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  margin-top:18px;
`

export const ErrorText = styled(BodySmall)`
  color: #FF3D3D;
  margin-left:6px;
`
